"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var GradeableTransaction_1 = __importDefault(require("./GradeableTransaction"));
var CQATaskCodes_1 = __importDefault(require("./CQATaskCodes"));
var CQAOptions_1 = __importDefault(require("./CQAOptions"));
var transactionlessInvoice = {
    id: 1,
    origInvoiceId: "1",
    transactions: [],
    department: {},
    status: "IN_CQA"
};
var FullTx = __assign(__assign({}, GradeableTransaction_1.default.CodeLessTransaction), { sequenceNumber: 0, id: 1, original: true, procedures: [__assign(__assign({}, CQATaskCodes_1.default.vanillaProcedure), { code: "J45.909" })], diagnoses: [
        __assign(__assign({}, CQATaskCodes_1.default.vanillaDiagnosis), { code: "99213", assessmentOptions: CQAOptions_1.default.CQAExampleAssessments, roleOptions: CQAOptions_1.default.CQAExampleRoles, codeAssessment: {
                role: "PRIMAY ICD/MEDICAL NECESSITY",
                assessment: "IDEAL ICD",
                id: 1
            } }),
        __assign(__assign({}, CQATaskCodes_1.default.vanillaDiagnosis), { code: "93000", assessmentOptions: CQAOptions_1.default.CQAExampleAssessments, roleOptions: CQAOptions_1.default.CQAExampleRoles, codeAssessment: {
                role: "INVALID AS PRIMARY",
                assessment: "GUIDELINE VIOLATION",
                id: 1
            } }),
        __assign(__assign({}, CQATaskCodes_1.default.vanillaDiagnosis), { code: "70450", assessmentOptions: CQAOptions_1.default.CQAExampleAssessments, roleOptions: CQAOptions_1.default.CQAExampleRoles })
    ], modifiers: [
        __assign(__assign({}, CQATaskCodes_1.default.vanillaModifier), { original: true, code: "LT", assessmentOptions: CQAOptions_1.default.CQAExampleAssessments, roleOptions: CQAOptions_1.default.CQAExampleRoles }),
        __assign(__assign({}, CQATaskCodes_1.default.vanillaModifier), { original: false, code: "LT", assessmentOptions: CQAOptions_1.default.CQAExampleAssessments, roleOptions: CQAOptions_1.default.CQAExampleRoles, sequenceNumber: 2 })
    ] });
var FullInvoice = __assign(__assign({}, transactionlessInvoice), { transactions: [
        FullTx,
        GradeableTransaction_1.default.Transaction,
        GradeableTransaction_1.default.NonOriginalTransaction
    ], department: {
        code: "123-456",
        name: "deptName"
    }, visit_reason: "reasonForVisit" });
var GradeableInvoiceFixtures = { transactionlessInvoice: transactionlessInvoice, FullInvoice: FullInvoice };
exports.default = GradeableInvoiceFixtures;
//# sourceMappingURL=GradeableInvoice.js.map